// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__33KAP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3Ksul","obliqueLine":"membershipbadge_obliqueLine__vVeo-"};